import { Provide } from '../ioc-container/ioc-container.ts';

@Provide()
export class SessionStorageWrapper {
	get(key: string): string | null {
		return sessionStorage.getItem(key);
	}

	set(key: string, value: string) {
		sessionStorage.setItem(key, value);
	}

	clear(key: string) {
		sessionStorage.removeItem(key);
	}
}
